import { Amplify } from 'aws-amplify'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { authConfig } from './config/auth'
import { AuthProvider } from './context/AuthContext'
import { CraftRoomProvider } from './context/CraftRoomContext'
import { UserRelationsProvider } from './context/UserRelationsContext.tsx'

// Load Google Fonts
const link = document.createElement('link')
link.href =
  'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Roboto:wght@400;500;600;700&display=swap'
link.rel = 'stylesheet'
document.head.appendChild(link)

Amplify.configure({
  Auth: authConfig,
})

// Create QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
})

// Render App
// Non-null assertion: 'root' element is guaranteed to exist in index.html
const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <UserRelationsProvider>
          <CraftRoomProvider>
            <App />
          </CraftRoomProvider>
        </UserRelationsProvider>
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>,
)
